/**
 * Mixin to provide savepoint rollback / re-apply functionality for bulk contact changes.
 */

export default {
    methods: {
        onClickStartRollback(savepoint_id, direction, on_complete) {
            let title = 'Reverse changes';
            let body = 'This will reverse all changes made to contacts by this bulk change.';

            if (direction === 'reapply') {
                title = 'Re-apply Changes';
                body = 'This will re-apply all changes made to contacts by this bulk change.';
            }

            this.$rc.confirm({
                title,
                body,
                btn_text_ok: 'Proceed',
                btn_text_cancel: 'Cancel',
                text_to_confirm_message: 'To proceed, type "proceed" below.',
                text_to_confirm: 'proceed',
                on_ok: () => {
                    this.doRollback(savepoint_id, direction, on_complete);
                },
            });
        },

        doRollback(savepoint_id, direction, on_complete) {
            this.$rc.showSpinner((direction === 'rollback' ? 'Reversing' : 'Re-applying')+' contact changes, this can take several minutes...');

            this.$rc.rest({
                spinner: false,
                endpoint: 'PUT: /api/v1/contacts/savepoint/rollback',
            
                params: {
                    savepoint_id,
                    direction,
                },
            
                on_success: (data) => {
                    const process_id = data.process_id;
                    const checks_remaining = 601; // 10 minutes...

                    this.onCheckRollbackProgress(process_id, checks_remaining, direction, on_complete);
                },
            
                on_error: 'Unable to '+(direction === 'rollback' ? 'reverse' : 're-apply')+' contact changes',
            });
        },

        onCheckRollbackProgress(process_id, checks_remaining, direction, on_complete) {
            if (checks_remaining < 0) {
                this.$rc.hideSpinner();
                this.$rc.alert((direction === 'rollback' ? 'Reverse' : 'Re-apply')+' contact changes failed', 'Unable to complete operation.  Please try again');
                return;
            }

            checks_remaining--;

            this.$rc.rest({
                spinner: false,
                endpoint: 'GET: /api/v1/async-process/:process_id',
            
                params: {
                    process_id,
                },
            
                on_success: (data) => {
                    if (data.state === 'finished') {
                        this.$rc.hideSpinner();

                        if (data.outcome === 'fail') {
                            this.$rc.alert('Change failed', 'An error prevented these changes from being applied');
                            return;
                        }

                        const count_deleted = data.output.count_deleted;
                        const count_upsert = data.output.count_upsert;

                        if (on_complete && typeof on_complete === 'function') {
                            on_complete();
                        }

                        this.$rc.alert('Change made', `This change to contacts has been made.<br/><br/>Contacts deleted: ${count_deleted}, Contacts created / updated: ${count_upsert}`);
                    } else {
                        window.setTimeout(
                            () => {
                                this.onCheckRollbackProgress(process_id, checks_remaining, direction, on_complete);
                            },
                            1000
                        );
                    }
                },
            
                on_error: 'Unable to apply the contact changes',
            });
        },
    },
}